import Feedback from ".";
import { connect } from "react-redux";
import { Selectors as AuthSelectors } from "@/store/auth/selectors";
import { Selectors as FavSelectors } from "@/store/favorites/selectors";
import { Selectors as ReviewSelectors } from "@/store/reviews/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Selectors as ProfileSelectors } from "@/store/saloonProfile/selectors";
import { Effects } from "@/store/reviews/effects";
import { Actions as ModalActions } from "@/store/modals/slice";

const mSp = (state) => ({
  reviews: ReviewSelectors.getReviews(state),
  loading: ReviewSelectors.isLoading(state),
  error: ReviewSelectors.getError(state),
  isMore: ReviewSelectors.isMore(state),
  favorites: FavSelectors.getFavoriteReviews(state),
  isOwner: ProfileSelectors.isOwner(state),
  isAuth: AuthSelectors.isAuth(state),
  authUserId: UserSelectors.getUserId(state),
  saloonId: ProfileSelectors.getId(state),
});
const mDp = {
  toggleLike: Effects.toggleLike,
  addComment: Effects.addComment,
  removeComment: Effects.removeComment,
  loadComments: Effects.loadComments,
  openShareModal: ModalActions.openShare,
  loadMore: Effects.loadReviews,
  updateReview: Effects.updateReview,
};

export default connect(mSp, mDp)(Feedback);
